export default "__VITE_ASSET__BAvJRQMb__"